export default {
    FROM: {
        EXAM_IN_PROGRESS: 'exam-in-progress',
        TIMETABLES: 'exam-timetables',
        SOVIET_PROTOCOLS: 'soviet-protocols',
    },
};
